import { ColumnsType } from 'antd/lib/table';
import { Division, Substitution } from 'app/services/edpApiV1/substitutions';
import { Substitutions } from 'features';
import { convertDate } from 'shared/helpers/date';
import { EmployeesUi } from 'entities/employees';
import { SubstitutionsTypes } from 'shared/enums';
import style from '../index.module.scss';

export const divisionsColumns: ColumnsType<Division> = [
  {
    title: 'Подразделение',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    sorter: true,
  },
  {
    title: 'Руководитель',
    dataIndex: ['supervisor'],
    key: 'supervisor',
    render: supervisor =>
      supervisor ? <EmployeesUi.SummaryInfo user={supervisor} /> : <span className={style.empty}>Не назначен</span>,
    sorter: true,
  },
  {
    title: 'Замещающий / И. О.',
    dataIndex: 'substitution',
    key: 'substitution',
    render: (substitution: Division['substitution'], record: Division) =>
      substitution ? (
        <EmployeesUi.SummaryInfo
          user={substitution.employee}
          suffix={substitution.type === SubstitutionsTypes.acting ? '(И.О.)' : '(Зам.)'}
        />
      ) : (
        <Substitutions.ControlButton
          {...(record.supervisor
            ? { substitutionType: SubstitutionsTypes.deputy, orgId: record.id }
            : { substitutionType: SubstitutionsTypes.acting, orgId: record.id })}
        />
      ),
  },
  {
    title: 'Дата начала',
    dataIndex: ['substitution', 'validFrom'],
    key: 'validFrom',
    render: (validFrom: string) => convertDate(validFrom),
  },
  {
    title: 'Дата окончания',
    dataIndex: ['substitution', 'validTo'],
    key: 'validTo',
    render: (validTo: string, record: Division) => {
      const isChanged = record.substitution && record.substitution.validToWasChangedBySupervisor;
      return (
        <>
          {isChanged && <div className={style.oldDate}>{convertDate(record.substitution.lastChange?.validTo)}</div>}
          <div className={isChanged ? style.warning : ''}>{convertDate(validTo)}</div>
        </>
      );
    },
  },
  {
    title: 'Автор замещения',
    dataIndex: ['substitution', 'creator'],
    key: 'creater',
    render: (creator: Division['substitution']['creator']) =>
      creator ? <EmployeesUi.SummaryInfo user={creator} /> : '',
  },
  {
    title: 'Дата создания/изменения',
    dataIndex: ['substitution', 'updated'],
    key: 'updated',
    render: (updated: string) => convertDate(updated),
  },
];

export const archiveColumns: ColumnsType<Substitution> = [
  {
    title: 'Подразделение',
    dataIndex: 'division',
    key: 'division',
    width: 200,
  },
  {
    title: 'Руководитель',
    dataIndex: ['supervisor'],
    key: 'supervisor',
    render: (supervisor: Substitution['supervisor']) =>
      supervisor ? <EmployeesUi.SummaryInfo user={supervisor} /> : <span className={style.empty}>Не назначен</span>,
  },
  {
    title: 'Замещающий / И. О.',
    dataIndex: 'employee',
    key: 'eymployee',
    render: (employee: Substitution['employee'], record: Substitution) =>
      employee ? (
        <EmployeesUi.SummaryInfo
          user={employee}
          suffix={record.type === SubstitutionsTypes.acting ? '(И.О.)' : '(Зам.)'}
        />
      ) : (
        ''
      ),
  },
  {
    title: 'Дата начала',
    dataIndex: 'validFrom',
    key: 'validFrom',
    render: (validFrom: string) => convertDate(validFrom),
  },
  {
    title: 'Дата окончания',
    dataIndex: 'validTo',
    key: 'validTo',
    render: (validTo: string) => convertDate(validTo),
  },
  {
    title: 'Автор замещения',
    dataIndex: ['creator'],
    key: 'creater',
    render: (creator: Division['substitution']['creator']) =>
      creator ? <EmployeesUi.SummaryInfo user={creator} /> : '',
  },
  {
    title: 'Дата создания/изменения',
    dataIndex: 'updated',
    key: 'updated',
    render: (updated: string) => convertDate(updated),
  },
];
